import { CreateFindingTypeRuleWithIndex, FindingTypeDetails, FindingTypeTemplateDetails } from './AnnotationStandardForm.slice';

const LOCALIZATION_GROUP = 'Localization';

export const validateDuplicatedRows = (
  newRules: CreateFindingTypeRuleWithIndex[],
  selectedFindingTypes: Array<FindingTypeTemplateDetails>,
  populatedFindingTypes: Array<FindingTypeDetails>
) => {
  const duplicateMarks: {
    templateId: string;
    index: number;
  }[] = [];

  selectedFindingTypes.forEach(findingTypeTemplate => {
    const templateRules = newRules.filter(x => x.findingTypeTemplateId === findingTypeTemplate.id);

    const findingTypeDetails = populatedFindingTypes.find(x => x.findingTypeTemplateId === findingTypeTemplate.id)!;
    const userProperties = findingTypeDetails.representations.filter(x => x.group !== LOCALIZATION_GROUP);
    const propertyIds = findingTypeTemplate.properties.filter(x => userProperties.map(y => y.title).includes(x.fullName)).map(x => x.id);

    const rulesGrouped = new Map<string, number[]>();

    templateRules.forEach(rule => {
      let grouped = '';

      propertyIds.forEach(propertyId => {
        const item = rule.items.find(x => x.findingTypePropertyId === propertyId);
        grouped += item ? `-${item.value}` : '-';
      });

      rulesGrouped.set(grouped, rulesGrouped.has(grouped) ? [...rulesGrouped.get(grouped)!, rule.index] : [rule.index]);
    });

    const newDuplicates = Array.from(rulesGrouped)
      .filter(([key, indexes]) => indexes && indexes.length > 1)
      .map(([key, indexes]) => [
        ...indexes.map(x => ({
          templateId: findingTypeTemplate.id,
          index: x
        }))
      ])
      .flat();

    duplicateMarks.push(...newDuplicates);
  });

  newRules = newRules.map(x => {
    if (duplicateMarks.find(y => y.templateId === x.findingTypeTemplateId && y.index === x.index)) {
      return {
        ...x,
        errorMark: true
      };
    }

    if (x.errorMark) {
      return {
        ...x,
        errorMark: false
      };
    }

    return x;
  });

  return newRules;
};

export const getInitialShowValue = (propertyName: string) => {
  if (propertyName === 'ShapeOnCanvas' || propertyName === 'HomographyShape') return false;
  return true;
};
